import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { of, Observable, forkJoin } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import * as compleWeb from './complemento-web.actions';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { AppStateComplementoWeb } from './complemento-web.reducer';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ActivarLoadingAction, DesactivarLoadingAction } from 'src/app/@store/actions';

@Injectable()
export class ComplementoWebEffects {


    constructor(
        private actions$: Actions,
        private store: Store<AppStateComplementoWeb>,
        private complementoWebService: ComplementoWebService,
        private router: Router,
    ) { }

    cargarDatosCatalogos$ = createEffect(() =>
        this.actions$.pipe(
            ofType(compleWeb.SolicitudCatalogosDetalleComplementoAction),
            switchMap((action) => {
                this.store.dispatch(ActivarLoadingAction());
                return forkJoin({
                    consultaSexo: this.complementoWebService.consultaSexo({ nombre_dato: null }).pipe(map(result => result.Resultado.Sexos)),
                    consultaTipoPerdida: this.complementoWebService.consultaTipoPerdida({ nombre_dato: null }).pipe(map(result => result.Resultado.TiposPerdida)),
                    consultaTipoEstimacion: this.complementoWebService.consultaTipoEstimaciones({ nombre_dato: null }).pipe(map(result => result.Resultado.Estimaciones)),
                    consultaSubtipoUbicaciones: this.complementoWebService.consultaSubTipoUbicaciones({ nombre_dato: null }).pipe(map(result => result.Resultado.SubTipoUbicaciones)),
                    consultaEstatusLesionado: this.complementoWebService.consultaEstatusLesionado({ nombre_dato: null }).pipe(map(result => result.Resultado.EstatusLesionado)),
                    consultaTipoGrua: this.complementoWebService.consultaTipoGrua({ nombre_dato: null }).pipe(map(result => result.Resultado.TiposGrua)),
                    consultaEventoServicio: this.complementoWebService.consultaEventoServicio({ nombre_dato: null }).pipe(map(result => result.Resultado.Eventos)),
                    consultaEstatusConcepto: this.complementoWebService.consultaEstatusConcepto({ nombre_dato: null }).pipe(map(result => result.Resultado.Estatus)),
                    consultaEstatusAbogado: this.complementoWebService.consultaEstatusAbogado({ nombre_dato: null }).pipe(map(result => result.Resultado.Estatus)),
                    consultaTradicionalTipo: this.complementoWebService.consultaTradicionalTipo({ nombre_dato: null }).pipe(map(result => result.Resultado.TradicionalTipos)),
                    consultaTipoUbicaciones: this.complementoWebService.consultaTipoUbicaciones({ nombre_dato: null }).pipe(map(result => result.Resultado.TipoUbicaciones)),
                    consultaTipoSiniestro: this.complementoWebService.consultaTipoSiniestro({ nombre_dato: null }).pipe(map(result => result.Resultado.TiposSiniestro)),
                    consultaPaises: this.complementoWebService.consultaPaises({ nombre_dato: null }).pipe(map(result => result.Resultado.Paises)),
                    consultaTiposRobo: this.complementoWebService.consultaTiposRobo({ nombre_dato: null }).pipe(map(result => result.Resultado.TiposRobo)),
                    consultaTipoPase: this.complementoWebService.consultaTipoPase({ nombre_dato: null }).pipe(map(result => result.Resultado.TipoPase)),
                    consultaTipoServicios: this.complementoWebService.consultaTipoServicios({ servicio: null }).pipe(map(result => result.Resultado.TipoServicios)),

                }).pipe(
                    switchMap((resultCatalogos) => {
                        this.store.dispatch(DesactivarLoadingAction());
                        return of(compleWeb.EstablecerCatalogosDetalleResultComplementoAction({ detalleComplemento: resultCatalogos }))
                    }
                    ),
                    catchError((error) => {
                        this.store.dispatch(DesactivarLoadingAction());
                        return of(compleWeb.ComplementoWebFailAction({ payload: error }))
                    })
                )
            })
        )
    );

    cargarDatosCatalogosTercero$ = createEffect(() =>
        this.actions$.pipe(
            ofType(compleWeb.SolicitudCatalogosTerceroDetalleComplementoAction),
            switchMap((action) => {
                this.store.dispatch(ActivarLoadingAction());
                return forkJoin({
                    consultaTipoTercero: this.complementoWebService.consultaTipoTercero({ nombre_dato: null }).pipe(map(result => result.Resultado.TiposTerceros)),
                    consultaTipoPersona: this.complementoWebService.consultaTipoPersona({ nombre_dato: null }).pipe(map(result => result.Resultado.TiposPersona)),
                    consultaCoberturas: this.complementoWebService.consultaCoberturas({ nombre_dato: null }).pipe(map(result => result.Resultado.Coberturas)),
                    consultaColores: this.complementoWebService.consultaColores({ nombre_dato: null }).pipe(map(result => result.Resultado.Colores)),
                    consultaCompanias: this.complementoWebService.consultaCompanias({ estatus: null, tipo_prestadork: null }).pipe(map(result => result.Resultado.Companias)),
                    consultaEstatus: this.complementoWebService.consultaEstatus({ nombre_dato: null }).pipe(map(result => result.Resultado.Estatus)),
                    consultaCategorias: this.complementoWebService.consultaCategorias({ nombre_dato: null }).pipe(map(result => result.Resultado.Categoria)),
                }).pipe(
                    switchMap((resultCatalogos) => {
                        this.store.dispatch(DesactivarLoadingAction());
                        return of(compleWeb.EstablecerCatalogosTerceroDetalleResultComplementoAction({ detalleComplemento: resultCatalogos }))
                    }),
                    catchError((error) => {
                        this.store.dispatch(DesactivarLoadingAction());
                        return of(compleWeb.ComplementoWebFailAction({ payload: error }))
                    })
                )
            })
        )
    );
}